export default {
  // Navigation
  nav_home: 'الرئيسية',
  nav_dashboard: 'لوحة القيادة',
  nav_orders: 'الطلبات',
  nav_wallet: 'المحفظة',
  nav_analytics: 'التحليلات',
  nav_referral: 'الإحالة',
  nav_account: 'الحساب',
  nav_notifications: 'الإشعارات',
  nav_logout: 'تسجيل الخروج',
  nav_login: 'تسجيل الدخول',
  nav_signup: 'إنضم إلينا',
  nav_deposit_requests: 'طلبات الإيداع',
  nav_withdraw_requests: 'طلبات السحب',
  nav_support_ticket: 'تذكرة الدعم',
  nav_system_logs: 'سجلات النظام',
  nav_announcements: 'الإعلانات',
  nav_activity_logs: 'سجلات النشاط',
  nav_settings: 'الإعدادات',
  nav_section_main: 'الرئيسي',
  nav_user_active: 'نشط الآن',
  nav_more: 'المزيد',
  nav_logout_confirm: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
  nav_language: 'اللغة',

  // Dashboard
  dashboard_welcome: 'مرحباً بعودتك',
  dashboard_total_earnings: 'إجمالي الأرباح',
  dashboard_pending_orders: 'الطلبات المعلقة',
  dashboard_completed_orders: 'الطلبات المكتملة',
  dashboard_commission_rate: 'نسبة العموله',
  dashboard_quick_actions: 'إجراءات سريعة',
  dashboard_recent_orders: 'الطلبات الأخيرة',
  dashboard_recent_activity: 'النشاط الأخير',
  dashboard_wallet_balance: 'رصيد المحفظة',
  dashboard_deposit: 'إيداع',
  dashboard_withdraw: 'سحب',
  dashboard_view_all: 'عرض الكل',
  greeting_morning: 'صباح الخير',
  greeting_afternoon: 'طاب مساؤك',
  greeting_evening: 'مساء الخير',
  dashboard_greeting_desc: 'تتبع أرباحك، وأكمل الطلبات، وقم بإدارة حسابك في مكان واحد. رحلة نجاحك تستمر هنا!',

  // Dashboard Stats
  stats_available_balance: 'الرصيد المتاح',
  stats_total_withdrawn: 'إجمالي المسحوبات',
  stats_total_deposit: 'إجمالي الإيداعات',
  stats_pending_orders: 'الطلبات المعلقة',
  stats_orders_suffix: ' طلبات',
  stats_task_earnings: 'أرباح المهام',
  stats_lifetime_earning: 'أرباح مدى الحياة',

  // Orders
  orders_title: 'طلباتي',
  orders_all: 'كل الطلبات',
  orders_pending: 'قيد الانتظار',
  orders_completed: 'مكتمل',
  orders_cancelled: 'ملغى',
  orders_order_id: 'رقم الطلب',
  orders_platform: 'المنصة',
  orders_amount: 'المبلغ',
  orders_commission: 'العمولة',
  orders_status: 'الحالة',
  orders_date: 'التاريخ',
  orders_actions: 'الإجراءات',
  orders_no_orders: 'لم يتم العثور على طلبات',

  // Wallet
  wallet_title: 'محفظتي',
  wallet_available_balance: 'الرصيد المتاح',
  wallet_pending_balance: 'الرصيد المعلق',
  wallet_total_withdrawn: 'إجمالي المسحوبات',
  wallet_deposit_now: 'إيداع الآن',
  wallet_withdraw_now: 'سحب الآن',
  wallet_transaction_history: 'سجل المعاملات',
  wallet_deposit_history: 'سجل الإيداع',
  wallet_withdrawal_history: 'سجل السحب',
  wallet_deposit_desc: "أضف المال إلى محفظتك باستخدام طرق الدفع المتاحة.",
  wallet_no_deposits: "لا توجد عمليات إيداع.",
  wallet_withdraw_history: "سجل السحب",
  wallet_withdraw_desc: "اسحب المال من محفظتك.",
  wallet_no_withdrawals: "لا توجد عمليات سحب.",
  wallet_no_withdrawals_desc: "لم تقم بأي عمليات سحب بعد.",

  // Analytics
  analytics_title: 'التحليلات',
  analytics_earnings_overview: 'نظرة عامة على الأرباح',
  analytics_platform_breakdown: 'توزيع المنصات',
  analytics_performance_metrics: 'مقاييس الأداء',
  analytics_top_products: 'أفضل المنتجات',
  analytics_this_month: 'هذا الشهر',
  analytics_last_month: 'الشهر الماضي',
  analytics_total_revenue: 'إجمالي الإيرادات',
  analytics_avg_order_value: 'متوسط قيمة الطلب',

  // Referral
  referral_title: 'برنامج الإحالة',
  referral_your_code: 'رمز الإحالة الخاص بك',
  referral_copy_code: 'نسخ الرمز',
  referral_share_link: 'مشاركة الرابط',
  referral_total_referrals: 'إجمالي الإحالات',
  referral_active_referrals: 'الإحالات النشطة',
  referral_referral_earnings: 'أرباح الإحالة',
  referral_invite_friends: 'دعوة الأصدقاء',

  // Account
  account_title: 'إعدادات الحساب',
  account_profile: 'الملف الشخصي',
  account_security: 'الأمان',
  account_notifications: 'الإشعارات',
  account_kyc: 'توثيق الهوية',
  account_phone: 'رقم الهاتف',
  account_two_factor: 'المصادقة الثنائية',
  account_save_changes: 'حفظ التغييرات',
  account_cancel: 'إلغاء',

  // Auth & Common
  auth_email: 'البريد الإلكتروني',
  auth_password: 'كلمة المرور',
  auth_confirm_password: 'تأكيد كلمة المرور',
  auth_forgot_password: 'هل نسيت كلمة المرور؟',
  auth_remember_me: 'تذكرني',
  auth_login_button: 'تسجيل الدخول',
  auth_signup_button: 'إنشاء حساب',
  auth_already_have_account: 'لديك حساب بالفعل؟',
  auth_dont_have_account: "ليس لديك حساب؟",
  auth_reset_password: 'إعادة تعيين كلمة المرور',
  auth_verify_email: 'التحقق من البريد الإلكتروني',
  auth_live_platform: 'المنصة المباشرة',
  auth_security_verification: 'التحقق الأمني',
  auth_captcha_refresh: 'تحديث',
  auth_captcha_placeholder: 'النتيجة',
  auth_captcha_error: 'المجموع غير صحيح، يرجى المحاولة مرة أخرى',
  auth_branding_title: 'حوّل العروض الترويجية إلى',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'دخل حقيقي',
  auth_branding_desc: 'انضم إلى آلاف المروجين الذين يكسبون عمولات يومية من أفضل العلامات التجارية للتجارة الإلكترونية في جميع أنحاء العالم.',
  auth_sign_in_to_account: 'سجل الدخول إلى حسابك في {{system_name}}',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'أدخل كلمة المرور الخاصة بك',
  auth_signing_in: 'جاري تسجيل الدخول...',
  auth_free_to_join: 'الانضمام مجاني',
  auth_signup_branding_title: 'ابدأ الكسب',
  auth_signup_branding_highlight: 'من اليوم الأول',
  auth_signup_branding_desc: 'لا حاجة للخبرة. سجل في دقيقتين وابدأ في إكمال المهام لأفضل العلامات التجارية للتجارة الإلكترونية.',
  auth_how_it_works: 'كيف يعمل',
  auth_signup_desc: 'انضم إلى {{system_name}} وابدأ في كسب العمولات اليوم - إنه مجاني!',
  auth_step_1: 'أنشئ حسابك المجاني',
  auth_step_2: 'تصفح وقبول المهام',
  auth_step_3: 'أكمل واكسب العمولات',
  auth_signup_step_1_title: 'إنشاء حساب',
  auth_signup_step_1_desc: 'ابدأ رحلتك',
  auth_signup_step_2_title: 'إكمال المهام',
  auth_signup_step_2_desc: 'اكسب عمولات يومية',
  auth_signup_step_3_title: 'سحب الأموال',
  auth_signup_step_3_desc: 'دفعات سريعة وآمنة',
  auth_benefit_1_title: 'آمن وموثوق',
  auth_benefit_1_desc: 'أمان بمستوى البنوك لأرباحك',
  auth_benefit_2_title: 'دفعات فورية',
  auth_benefit_2_desc: 'اسحب أرباحك خلال 24 ساعة',
  auth_benefit_3_title: 'مجتمع عالمي',
  auth_benefit_3_desc: 'انضم إلى أكثر من 12,000 مروج نشط',
  auth_benefit_4_title: 'دعم 24/7',
  auth_benefit_4_desc: 'احصل على المساعدة وقتما تحتاجها',

  common_loading: 'جاري التحميل...',
  common_save: 'حفظ',
  common_cancel: 'إلغاء',
  common_delete: 'حذف',
  common_edit: 'تعديل',
  common_view: 'عرض',
  common_search: 'بحث',
  common_filter: 'فلترة',
  common_export: 'تصدير',
  common_import: 'استيراد',
  common_submit: 'إرسال',
  common_close: 'إغلاق',
  common_confirm: 'تأكيد',
  common_success: 'نجاح',
  common_error: 'خطأ',
  common_warning: 'تحذير',
  common_announcement: 'إعلان',

  val_full_name_required: 'الاسم الكامل مطلوب',
  val_email_required: 'البريد الإلكتروني مطلوب',
  val_password_required: 'كلمة المرور مطلوبة',
  val_password_min: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  val_passwords_dont_match: 'كلمات المرور غير متطابقة',
  val_agree_terms: 'يجب عليك الموافقة على الشروط',
  val_conn_error: 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',

  // Homepage
  home_hero_title: 'اكسب عمولة من أفضل منصات التجارة الإلكترونية',
  home_hero_subtitle: 'انضم إلى آلاف المستخدمين الذين يكسبون عمولات يومية من أمازون وعلي بابا وعلي إكسبريس',
  home_get_started: 'ابدأ الآن',
  home_learn_more: 'تعرف على المزيد',
  home_how_it_works: 'كيف يعمل',
  home_features: 'الميزات',
  home_why_choose_us: 'لماذا تختارنا',
  home_features_title: 'ميزات قوية',
  home_features_subtitle: 'كل ما تحتاجه للبدء في الكسب عبر الإنترنت. صُمم مع مراعاة نجاحك.',
  home_commission_tiers: 'مستويات العمولة',
  home_testimonials: 'ماذا يقول مستخدمونا',
  home_faq: 'الأسئلة الشائعة',
  home_cta_title: 'هل أنت مستعد لبدء الكسب؟',
  home_cta_subtitle: 'انضم إلى مجتمعنا اليوم وابدأ في كسب العمولات',
  home_trusted_partner: 'منصات شركاء موثوقة',
  home_secure_platform: 'منصة آمنة',
  home_instant_payouts: 'دفعات فورية',
  home_active_users: 'المستخدمون النشطون',
  home_total_paid_out: 'إجمالي المبالغ المدفوعة',
  home_user_rating: 'تقييم المستخدمين',
  home_countries: 'الدول',

  // Feature Section
  feature_1_title: 'دفعات فورية',
  feature_1_desc: 'احصل على أرباحك فوراً بعد إكمال الطلب. اسحب في أي وقت دون تأخير.',
  feature_1_detail_1: 'قيد سريع للعمولة',
  feature_1_detail_2: 'خيارات سحب متعددة',
  feature_1_detail_3: 'لا يوجد حد أدنى للسحب',
  feature_2_title: 'منصة آمنة',
  feature_2_desc: 'تشفير بمستوى البنوك يحمي بياناتك وأرباحك. موثوق به من قبل آلاف المستخدمين في جميع أنحاء العالم.',
  feature_2_detail_1: 'تشفير SSL مفعل',
  feature_2_detail_2: 'المصادقة الثنائية',
  feature_2_detail_3: 'تدقيق أمني دوري',
  feature_2_detail_4: 'خصوصية البيانات مضمونة',
  feature_3_title: 'ساعات مرنة',
  feature_3_desc: 'اعمل وقتما تشاء ومن أي مكان. أكمل الطلبات بالسرعة التي تناسبك دون جدول زمني محدد.',
  feature_3_detail_1: 'لا توجد ساعات عمل ثابتة',
  feature_3_detail_2: 'اعمل من أي مكان',
  feature_3_detail_3: 'اختر الوتيرة الخاصة بك',
  feature_3_detail_4: 'متاح في عطلات نهاية الأسبوع',
  feature_4_title: 'أرباح تصاعدية',
  feature_4_desc: 'افتح مستويات عمولة أعلى مع إكمال المزيد من الطلبات. ضاعف دخلك مع كل ترقية للمستوى.',
  feature_4_detail_1: 'مستويات عمولة متدرجة',
  feature_4_detail_2: 'ترقيات تلقائية للمستوى',
  feature_4_detail_3: 'مكافآت الأداء',
  feature_5_title: 'منصة عالمية',
  feature_5_desc: 'اعمل مع علامات تجارية عالمية من أي مكان في العالم. دعم العملات المتعددة متضمن.',
  feature_5_detail_1: 'متوفر عالمياً',
  feature_5_detail_2: 'دعم عملات متعددة',
  feature_5_detail_3: 'طرق دفع محلية',

  // Home Page Additional Sections
  home_how_it_works_badge: 'عملية بسيطة',
  home_how_it_works_title: 'كيف يعمل',
  home_how_it_works_subtitle: 'ابدأ الكسب في 4 خطوات بسيطة. لا حاجة للخبرة، فقط اتبع العملية وشاهد أرباحك تنمو.',
  home_cta_ready_title: 'هل أنت مستعد لبدء رحلتك؟',
  home_cta_ready_desc: 'انضم إلى آلاف المستخدمين الذين يكسبون يومياً بالفعل. عمولتك الأولى تفصلك عنها دقائق معدودة!',
  home_cta_avg_time: 'متوسط الوقت لأول كسب:',
  home_cta_15_mins: '15 دقيقة',
  home_cta_new_users: 'مستخدمون جدد اليوم:',

  // How It Works Steps
  step_1_title: 'إنشاء حساب',
  step_1_desc: 'أنشئ حسابك في أقل من دقيقتين.',
  step_1_detail_1: 'قدم المعلومات الأساسية',
  step_1_detail_2: 'تحقق من بريدك الإلكتروني',
  step_1_detail_3: 'أمن حسابك',
  step_1_detail_4: 'وصول فوري للوحة التحكم',

  step_2_title: 'البحث عن المهام',
  step_2_desc: 'اختر من مهام الترويج المتاحة.',
  step_2_detail_1: 'تصفية حسب المنصة',
  step_2_detail_2: 'عرض نسب العمولة',
  step_2_detail_3: 'قبول مهام متعددة',
  step_2_detail_4: 'تحديثات للمهام في الوقت الفعلي',

  step_3_title: 'إكمال المهام',
  step_3_desc: 'أكمل العروض الترويجية وفقاً للتعليمات.',
  step_3_detail_1: 'خطوات سهلة المتابعة',
  step_3_detail_2: 'تقديم سريع للمهام',
  step_3_detail_3: 'تحقق تلقائي',
  step_3_detail_4: 'واجهة متوافقة مع الجوال',

  step_4_title: 'كسب وسحب',
  step_4_desc: 'احصل على أموالك مقابل كل مهمة مكتملة.',
  step_4_detail_1: 'تتبع الأرباح في الوقت الفعلي',
  step_4_detail_2: 'حد أدنى منخفض للسحب',
  step_4_detail_3: 'طرق دفع متعددة',
  step_4_detail_4: 'دعم السحب 24/7',
};